import { useCallback, useState } from 'react';

export const TOAST_AUTO_DISMISS_STORAGE_KEY = 'toast_auto_dismiss_ms';

export const TOAST_AUTO_DISMISS_OPTIONS = [0, 5000, 15000, 30000, 60000, 300000, 900000] as const;

const acceptedToastAutoDismissValues = new Set<number>(TOAST_AUTO_DISMISS_OPTIONS);

function normalizeToastAutoDismissMs(value: number): number {
  return acceptedToastAutoDismissValues.has(value) ? value : 0;
}

export function getToastAutoDismissMs(): number {
  if (typeof window === 'undefined') {
    return 0;
  }

  const raw = window.localStorage.getItem(TOAST_AUTO_DISMISS_STORAGE_KEY);
  if (!raw) {
    return 0;
  }

  const parsed = Number.parseInt(raw, 10);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return normalizeToastAutoDismissMs(parsed);
}

export function setToastAutoDismissMs(ms: number): void {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeToastAutoDismissMs(ms);
  window.localStorage.setItem(TOAST_AUTO_DISMISS_STORAGE_KEY, normalized.toString());
}

export function useToastPreferences() {
  const [autoDismissMs, setAutoDismissMsState] = useState<number>(() => getToastAutoDismissMs());

  const setAutoDismissMs = useCallback((ms: number) => {
    const normalized = normalizeToastAutoDismissMs(ms);
    setToastAutoDismissMs(normalized);
    setAutoDismissMsState(normalized);
  }, []);

  return {
    autoDismissMs,
    setAutoDismissMs,
  };
}
